import React from 'react';

export default function TimelineMilestone({ year, heading, desc, glowClass, icon }) {
  return (
    <div className="timeline-milestone-stop-point">
      <div className={`stop-circle-icon ${glowClass}`}>{icon}</div>
      <strong>{year}</strong>
      <h5>{heading}</h5>
      <p>{desc}</p>
    </div>
  );
}